// extracted by mini-css-extract-plugin
export default {"Container":"TableWrapper_Container__VPZqO"};